<style lang="scss" scoped>
.unauthorized {
	margin: 0 auto;
	text-align: center;
	i {
		font-size: 3em;
		color: red;
	}
	&__message {
		margin: 20px 0 30px;
	}
}
</style>

<template lang="pug">
.unauthorized
	i.fe.fe-x-square
	.unauthorized__message
		.unauthorized__message--permission(v-if="$route.query.permission")
			h2 Missing permission: 
			h4 {{ $route.query.permission }}
		.unauthorized__message--general(v-else)
			h1 You are not authorized
	el-button(type='primary', @click="handleClick") Go back
</template>

<script>
export default {
	methods: {
		handleClick() {
			this.$router.push("/");
		}
	}
};
</script>
